// extracted by mini-css-extract-plugin
export var indeterminate = "_1t-5";
export var md = "_1t-4";
export var semantic = "_1t-6";
export var sm = "_1t-3";
export var text = "_1t-7";
export var toggleInput = "_1t-0";
export var toggleSwitch = "_1t-1";
export var xs = "_1t-2";